import type { LayoutProps } from '@jsonforms/core'
import { withJsonFormsLayoutProps } from '@jsonforms/react'

import { TwoColumnsLayout as TwoColumnsLayoutWithoutMUI } from '../../../../concorde-renderers/layouts'
import { useJourneyContext } from '../../../providers'

import TwoColumnsLayoutWithMUI from './MainContentCartLayout'

const TwoColumnsLayoutWithMUIWithProps = withJsonFormsLayoutProps(
  TwoColumnsLayoutWithMUI
)
const TwoColumnsLayoutWithoutMUIWithProps = withJsonFormsLayoutProps(
  TwoColumnsLayoutWithoutMUI
)

function TwoColumnsLayout(props: LayoutProps) {
  const { context } = useJourneyContext()

  const useNewDesign = context.journey.settings?.useNewDesign

  return useNewDesign ? (
    <TwoColumnsLayoutWithoutMUIWithProps {...props} />
  ) : (
    <TwoColumnsLayoutWithMUIWithProps {...props} />
  )
}

export default TwoColumnsLayout
